import { DonorType } from '@/api/apis/case';
import { BloodSection } from './components/BloodSection';
import { CaseMatchSection } from './components/CaseMatchSection';
import { DonorDemographicsSection } from './components/DonorDemographicsSection';
import { LiverAdditionalInfoSection } from './components/LiverAdditionalInfoSection';
import { ParametersSection } from './components/ParametersSection';

type LiverDonorProfileFormProps = {
  donorType?: DonorType | null;
};

export const LiverDonorProfileForm = ({ donorType }: LiverDonorProfileFormProps) => (
  <div className="flex flex-col gap-6">
    <CaseMatchSection />
    <DonorDemographicsSection />
    <ParametersSection donorType={donorType} />
    <BloodSection />
    <LiverAdditionalInfoSection />
  </div>
);
